<div class="graph-wrapper">
    <div class="header">
        <h4 class="ellipses d-flex">Cost Contribution by ABCD
            &nbsp;
            <div [popover]="popTemplate" triggers="mouseenter:mouseleave" container="body" placement="bottom">

                <img src="../../../assets/images/icn-info.svg" alt="">
            </div>
        </h4>
        <div class="minimise" mat-dialog-close></div>
    </div>
    <div #graphDiv width="100%" height="100%" class="bar-chart" id="graphDiv"></div>
</div>
<ng-template #popTemplate>
    <div class="mb-15">Cost Contribution classification across A/B/C/D/Unclassified SKU categories at Line level
    </div>

    <div class="tooltip-formula">
        <div class="tooltip-left">
            Cost Contribution =
        </div>
        <div class="tooltip-center">
            <div class="tooltip-center-top">
                waste cost generated by A/B/C/D/Unclassified categories

            </div>
            <hr class="tooltip-center-middle">
            <div class="tooltip-center-bottom">
                total waste cost generated at the Line
            </div>

        </div>
        <div class="tooltip-right">
            * 100
        </div>
    </div>

</ng-template>